import { isValidEmail } from '../../../../util';

/**
 * Formats a string as a `mailto:` URL if it is a valid email address and doesn't already start with `mailto:`.
 *
 * @param url URL to format
 * @returns {string} formatted URL
 */
export const formatUrl = (url?: string) => {
  if (!url || !isValidEmail(url) || url.startsWith('mailto:')) {
    return url;
  }

  return `mailto:${url}`;
};
